export default __webpack_public_path__ + "static/media/Type 16.905dd080.jpg";